import { SaveOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, notification, Row, Typography } from "antd";
import { ContainerComponent } from "../../../../../components";
import ImageUploaderAntd from "../../../../../components/image-uploader-antd";
import { useQuery } from "../../../../../hooks";
import { useMutation } from "../../../../../hooks/use-mutation";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/devboost.css";
import { DevStageBlock } from "../partials/dev-stage-block.partial";
import { Feedback } from "../partials/feedback.partial";
import { TechnologiesCatalog } from "../partials/technologies-catalog.partial";
import { TechnologiesSelect } from "../partials/technologies-select.partial";

const { TextArea } = Input;

export const DevBoostFormView = ({ mode = "create", initialValues = {} }) => {
    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification()
    const [form] = Form.useForm();
    const [optimizationRangePlanning, setOptimizationRangePlanning] = useState([]);
    const [optimizationRangeDev, setOptimizationRangeDev] = useState([]);
    const [optimizationRangeTesting, setOptimizationRangeTesting] = useState([]);
    const [optimizationRangeDevOps, setOptimizationRangeDevOps] = useState([]);
    const [allTechnologies, setAllTechnologies] = useState([]);

    const { data: technologies, execute: getTechnologies } = useQuery({
        url: "/catalogtechnology",
        options: { method: "GET" },
    })


    // Cargar datos iniciales si es edición
    useEffect(() => {
        if (mode === "edit" && initialValues) {
            form.setFieldsValue(initialValues);
            setOptimizationRangePlanning(initialValues.optimizationRangePlanning || []);
            setOptimizationRangeDev(initialValues.optimizationRangeDev || []);
            setOptimizationRangeTesting(initialValues.optimizationRangeTesting || []);
            setOptimizationRangeDevOps(initialValues.optimizationRangeDevOps || []);
        }
    }, [mode, initialValues, form]);

    useEffect(() => {
        setAllTechnologies(technologies?.map(t => { return { label: t.name, value: t.id } }) || []);
    }, [technologies])



    // Configuración de useMutation según modo
    const mutationConfig = mode === "edit"
        ? { url: `/devboost`, method: "PUT" }
        : { url: "/devboost", method: "POST" };

    const { loading, executeMutation } = useMutation({
        ...mutationConfig,
        onSuccess: () => {
            api.success({
                message: mode === "edit" ? "Actualizado correctamente" : "Guardado correctamente",
                duration: 3,
                className: "custom-notification-bg",
            });
            if (mode === "edit") {
                navigate(`/dev-boost`);
            } else {
                form.resetFields();
            }
        },
        onError: (err) => {
            api.error({
                message: "Error al guardar",
                description: err.message,
                className: "custom-notification-bg",
                duration: 3,
            });
        }
    });

    const onFinish = async () => {
        const values = await form.validateFields();

        const ranges = [
            { name: "Planificación y Diseño", value: optimizationRangePlanning },
            { name: "Desarrollo y Codificación", value: optimizationRangeDev },
            { name: "Pruebas y Depuración", value: optimizationRangeTesting },
            { name: "Despliegue y Operaciones (DevOps)", value: optimizationRangeDevOps }
        ];

        for (const range of ranges) {
            if (
                !Array.isArray(range.value) ||
                range.value.length !== 2 ||
                !range.value[0] ||
                !range.value[1] ||
                range.value[0] <= 0 ||
                range.value[1] <= 0
            ) {
                api.error({
                    message: `Rango inválido en "${range.name}"`,
                    description: "Ambos valores deben ser mayores a 0 y no estar vacíos.",
                    className: "custom-notification-bg",
                    duration: 3,
                });
                return;
            }
        }

        const payload = {
            id: values.id,
            title: values.title,
            successStoryImg: values.successStoryImg,
            problemDescription: values.problemDescription,
            industry: values.industry,
            technologies: values.technologies || [],
            impactPlanning: values.impactPlanning,
            examplePlanning: values.examplePlanning,
            optimizationRangePlanning: optimizationRangePlanning,
            impactDev: values.impactDev,
            exampleDev: values.exampleDev,
            optimizationRangeDev: optimizationRangeDev,
            impactTesting: values.impactTesting,
            exampleTesting: values.exampleTesting,
            optimizationRangeTesting: optimizationRangeTesting,
            impactDevOps: values.impactDevOps,
            exampleDevOps: values.exampleDevOps,
            optimizationRangeDevOps: optimizationRangeDevOps,
            score: values.score,
            benefits: values?.benefits || [],
            challenge: values.challenge,
            comment: values.comment
        };

        // console.log({ payload });
        // console.log("Guardar: " + JSON.stringify(payload));

        executeMutation(payload);
    };

    const onFinishFailed = ({ errorFields }) => {
        api.warning({
            message: "Campos incompletos",
            description: "Por favor, completa todos los campos requeridos antes de guardar.",
            placement: "topRight",
            className: "custom-notification-bg",
            duration: 3,
        });
        if (errorFields && errorFields.length > 0) {
            form.scrollToField(errorFields[0].name);
        }
    }

    return (
        <>
            {contextHolder}
            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <ContainerComponent
                    style={{
                        backgroundColor: "#ffffff",
                        padding: 24,
                        borderRadius: 16,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                        marginBottom: 24,
                    }}
                >
                    <Row>
                        <Col span={24}>
                            <Typography.Title style={{ textAlign: "left" }} level={3}>
                                Datos Generales del Caso de Éxito
                            </Typography.Title>
                        </Col>
                    </Row>
                    <Row gutter={[0, 0]}>
                        <Col xs={24} sm={24} md={18}>
                            <div style={{
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Form.Item
                                    name="id"
                                    style={{ display: "none", margin: 0 }}
                                    rules={[{ required: false, message: "Requerido" }]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    name="title"
                                    label="Título del Caso de Éxito"
                                    rules={[{ required: true, message: "Requerido" }]}
                                    style={{
                                        marginBottom: 0,
                                        flex: 1
                                    }}
                                >
                                    <Input name="title" maxLength={80} />
                                </Form.Item>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                            <Form.Item
                                name="successStoryImg"
                                label="Imagen del Caso de Éxito"
                                rules={[{ required: true, message: "Requerido" }]}
                                style={{
                                    marginBottom: 8,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}
                            >
                                <ImageUploaderAntd
                                    initialValue={initialValues?.successStoryImg}
                                    onSaved={(imageUrl) =>
                                        form.setFieldsValue({ successStoryImg: imageUrl })
                                    }
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item
                                name="problemDescription"
                                label="Descripción del Problema"
                                rules={[{ required: true, message: "Requerido" }]}
                                style={{
                                    marginBottom: 0,
                                    flex: 1
                                }}
                            >
                                <TextArea name="problemDescription" maxLength={120} autoSize />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={12}>
                            <Form.Item
                                name="industry"
                                label="Industria/Sector"
                                rules={[{ required: true, message: "Requerido" }]}
                            >
                                <Input
                                    name="industry"
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                            <Row gutter={8} align="middle" wrap={false}>
                                <Col flex="auto">
                                    <Form.Item
                                        name="technologies"
                                        label="Tecnologías Utilizadas"
                                        rules={[{ required: true, message: "Requerido" }]}
                                        validateTrigger="onSubmit"
                                        style={{ marginBottom: 0 }}
                                        getValueProps={(val) => ({
                                            value: Array.isArray(val)
                                                ? val.map(t => ({ value: t.id, label: t.name }))
                                                : []
                                        })}
                                        normalize={(val) =>
                                            val.map(v => ({ id: v.value, name: v.label }))
                                        }
                                    >
                                        <TechnologiesSelect
                                            options={allTechnologies}
                                            refreshOptions={async () => {
                                                await getTechnologies();
                                                return technologies;
                                            }}
                                            notificationAPI={api}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item label=" " colon={false} style={{ marginBottom: 0 }}>
                                        <TechnologiesCatalog
                                            technologies={technologies || []}
                                            notificationAPI={api}
                                            onSuccessfullyRequest={() => {
                                                getTechnologies();
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </ContainerComponent>
                <ContainerComponent
                    style={{
                        marginBottom: 8
                    }}
                >
                    <Row>
                        <Col span={24}>
                            <Typography.Title style={{ textAlign: "left" }} level={3}>
                                Impacto de Copilot por Etapa de Desarrollo
                            </Typography.Title>
                        </Col>
                    </Row>
                </ContainerComponent>
                <ContainerComponent
                    style={{
                        padding: 24,
                        marginBottom: 24,
                        backgroundColor: "#ffffff",
                        borderRadius: 16,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Row>
                        <Col span={24}>
                            <DevStageBlock
                                title="Planificación y Diseño"
                                impactName="impactPlanning"
                                exampleName="examplePlanning"
                                optimizationRange={optimizationRangePlanning}
                                setOptimizationRange={setOptimizationRangePlanning}
                            />
                        </Col>
                    </Row>
                </ContainerComponent>
                <ContainerComponent
                    style={{
                        padding: 24,
                        marginBottom: 24,
                        backgroundColor: "#ffffff",
                        borderRadius: 16,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Row>
                        <Col span={24}>
                            <DevStageBlock
                                title="Desarrollo y Codificación"
                                impactName="impactDev"
                                exampleName="exampleDev"
                                optimizationRange={optimizationRangeDev}
                                setOptimizationRange={setOptimizationRangeDev}
                            />
                        </Col>
                    </Row>
                </ContainerComponent>
                <ContainerComponent
                    style={{
                        padding: 24,
                        marginBottom: 24,
                        backgroundColor: "#ffffff",
                        borderRadius: 16,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Row>
                        <Col span={24}>
                            <DevStageBlock
                                title="Pruebas y Depuración"
                                impactName="impactTesting"
                                exampleName="exampleTesting"
                                optimizationRange={optimizationRangeTesting}
                                setOptimizationRange={setOptimizationRangeTesting}
                            />
                        </Col>
                    </Row>
                </ContainerComponent>
                <ContainerComponent
                    style={{
                        padding: 24,
                        marginBottom: 24,
                        backgroundColor: "#ffffff",
                        borderRadius: 16,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Row>
                        <Col span={24}>
                            <DevStageBlock
                                title="Despliegue y Operaciones (DevOps)"
                                impactName="impactDevOps"
                                exampleName="exampleDevOps"
                                optimizationRange={optimizationRangeDevOps}
                                setOptimizationRange={setOptimizationRangeDevOps}
                            />
                        </Col>
                    </Row>
                </ContainerComponent>
                <ContainerComponent
                    style={{
                        padding: 24,
                        marginBottom: 24,
                        backgroundColor: "#ffffff",
                        borderRadius: 16,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Row>
                        <Col span={24}>
                            <Typography.Title style={{ textAlign: "left" }} level={3}>
                                Impacto General y Retroalimentación
                            </Typography.Title>
                        </Col>
                    </Row>

                    <Feedback />
                </ContainerComponent>
                {/* <ContainerComponent
                    style={{
                        padding: "24px 24px 0 24px",
                        marginBottom: 24,
                        backgroundColor: "#ffffff",
                        borderRadius: 16,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Row>
                        <Col span={24}>
                            <Form.Item style={{ textAlign: "end" }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    style={{ marginRight: 8, backgroundColor: "var(--color-secondary)" }}
                                    loading={loading}
                                    disabled={loading}
                                >
                                    {mode === "edit" ? "Actualizar" : "Guardar"}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </ContainerComponent> */}
            </Form>
            <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={loading}
                disabled={loading}
                style={{
                    position: "fixed",
                    bottom: 32,
                    right: 32,
                    zIndex: 2000,
                    backgroundColor: "var(--color-secondary)",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
                }}
                onClick={() => form.submit()}
            >
                <SaveOutlined />
                {mode === "edit" ? "Actualizar" : "Guardar"}
            </Button>
        </>
    )
}
